<template>
  <div class="modal" v-show="show" @click="taggle(false)">
    <div class="modal-body">
      <h6 class="title">{{title}}</h6>
      <p class="content">{{content}}</p>
      <div class="tool-bar">
        <button @click.prevent.stop="taggle(false)" class="btn confirm-btn">我知道了</button>
        <button v-if="download" @click.prevent.stop="downloadApp" class="btn">下载川观客户端</button>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    props: {
      title:{
        type: String,
        default: '提示'
      },
      content:{
        type: String
      },
      download:{
        type: Boolean,
        default: false
      }
    },
    data(){
      return {
        show: true
      }
    },
    methods: {
      taggle(status){
        this.show = status || !this.show;
      },
      downloadApp(){
        window.location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.sichuanol.cbgc';
      }
    }
  }
</script>
<style lang="scss">
  .modal{
    position: fixed;
    left:0;top:0;
    width: 100vw;
    height: 100vh;
    z-index: 90;
    font-size: inherit;
    .modal-body{
      position: fixed;
      left: 50%;
      top: 46%;
      transform: translate(-50%, -50%);
      padding: 2em 1em;
      width: 60vw;
      /* color: #fff; */
      background-color: rgba(255,255,255,1);
      box-shadow: 1px 1px 3px rgba(0,0,0,.5);
      border-radius: .5em;
    }
    .title{
      text-align: center;
      font-size: 1.2em;
      padding-bottom: .5em;
      border-bottom: .02em solid rgba(0,0,0,.5);
    }
    .content{
      margin: 2em auto;
    }
    .tool-bar{
      display: flex;
      justify-content: space-between;
      align-items: center;
      
      .btn{
        padding: .5em 1em;
        background-color:#da251d;
        color: #fff;
        margin: 0 auto;
        border-radius: .5em;
        border: 1px solid #e31e15;
      }
      .confirm-btn{
        /* background-color: #ccc;
        color: #000;
        border: 1px solid #bbb; */
      }
    }
  }
</style>